import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ImageType = /*#__PURE__*/function (ImageType) {
  ImageType[ImageType["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  ImageType[ImageType["PRIMARY"] = 1] = "PRIMARY";
  ImageType[ImageType["LOGO"] = 2] = "LOGO";
  return ImageType;
}(ImageType || {});
// *********************************

function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AssociateImageRequest {
  static fromProto(proto) {
    let m = new AssociateImageRequest();
    m = Object.assign(m, proto);
    if (proto.imageType) {
      m.imageType = enumStringToValue(ImageType, proto.imageType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.imageId !== 'undefined') {
      toReturn['imageId'] = this.imageId;
    }
    if (typeof this.imageType !== 'undefined') {
      toReturn['imageType'] = this.imageType;
    }
    return toReturn;
  }
}
class DeleteImageRequest {
  static fromProto(proto) {
    let m = new DeleteImageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.imageId !== 'undefined') {
      toReturn['imageId'] = this.imageId;
    }
    return toReturn;
  }
}
class ListImagesRequestFilters {
  static fromProto(proto) {
    let m = new ListImagesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.imageType) {
      m.imageType = proto.imageType.map(v => enumStringToValue(ImageType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.imageType !== 'undefined') {
      toReturn['imageType'] = this.imageType;
    }
    if (typeof this.includeDeleted !== 'undefined') {
      toReturn['includeDeleted'] = this.includeDeleted;
    }
    return toReturn;
  }
}
class ImageAssociation {
  static fromProto(proto) {
    let m = new ImageAssociation();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.imageType) {
      m.imageType = enumStringToValue(ImageType, proto.imageType);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.imageId !== 'undefined') {
      toReturn['imageId'] = this.imageId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.imageType !== 'undefined') {
      toReturn['imageType'] = this.imageType;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class ListImagesPagedResponse {
  static fromProto(proto) {
    let m = new ListImagesPagedResponse();
    m = Object.assign(m, proto);
    if (proto.images) {
      m.images = proto.images.map(ImageAssociation.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.images !== 'undefined' && this.images !== null) {
      toReturn['images'] = 'toApiJson' in this.images ? this.images.toApiJson() : this.images;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListImagesRequest {
  static fromProto(proto) {
    let m = new ListImagesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filters) {
      m.filters = ListImagesRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'account-group-media-api.vendasta-local.com',
  'test': '',
  'demo': 'account-group-media-api-demo.apigateway.co',
  'prod': 'account-group-media-api-prod.apigateway.co',
  'production': 'account-group-media-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MediaApiService = /*#__PURE__*/(() => {
  class MediaApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    associateImage(r) {
      const request = r.toApiJson ? r : new AssociateImageRequest(r);
      return this.http.post(this._host + "/accountgroupmedia.v1.MediaService/AssociateImage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listImages(r) {
      const request = r.toApiJson ? r : new ListImagesRequest(r);
      return this.http.post(this._host + "/accountgroupmedia.v1.MediaService/ListImages", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListImagesPagedResponse.fromProto(resp)));
    }
    deleteImage(r) {
      const request = r.toApiJson ? r : new DeleteImageRequest(r);
      return this.http.post(this._host + "/accountgroupmedia.v1.MediaService/DeleteImage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  MediaApiService.ɵfac = function MediaApiService_Factory(t) {
    return new (t || MediaApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MediaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MediaApiService,
    factory: MediaApiService.ɵfac,
    providedIn: 'root'
  });
  return MediaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AssociateImageRequest, DeleteImageRequest, ImageAssociation, ImageType, ListImagesPagedResponse, ListImagesRequest, ListImagesRequestFilters, MediaApiService };
